import { Flex, Text } from "@wayflyer/flyui";

import styles from "./months-coverage-bar.module.css";

import type { MonthCoverage, MonthCoverageFill } from "../utils";

type MonthsCoverageBarProps = {
  months: MonthCoverage[];
};

const FILL_CLASS_NAME: Record<MonthCoverageFill, string> = {
  none: styles.unfilled,
  "half-start": styles.halfStart,
  "half-end": styles.halfEnd,
  full: styles.filled,
  reviewed: styles.reviewed,
};

export const MonthsCoverageBar = ({ months }: MonthsCoverageBarProps) => (
  <Flex direction="column" gap="3">
    <Flex gap="var(--space-component-xxxs)">
      {months.map((month, index) => (
        <div key={index} className={`${styles.segment} ${FILL_CLASS_NAME[month.fill]}`} />
      ))}
    </Flex>
    <Flex gap="var(--space-component-xxxs)">
      {months.map((month, index) => (
        <div key={index} className={styles.label}>
          <Text size="xs" color="subtle">
            {month.label}
          </Text>
        </div>
      ))}
    </Flex>
  </Flex>
);
